module.exports = __webpack_public_path__ + "img/3.f376f8d7.png";